export const DOWNLOAD_CONFIG = {
  OUTPUT_FORMAT: 'zip',
  FILE_EXTENSION: '.zip',
} as const;

export const DOWNLOAD_JOB_CONFIG = {
  POLL_INTERVAL_MS: 2000,
} as const;

export enum DownloadStatus {
  IDLE = 'idle',
  PREPARING = 'preparing',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export enum JobStatus {
  QUEUED = 'queued',
  PROCESSING = 'processing',
  COMPLETE = 'complete',
  FAILED = 'failed',
}
